import type { AuthState } from 'types';

/**
 * Builds the auth state for an identity switch (impersonation / substitution).
 * The impersonated JWT must always replace the stored one — otherwise the UI
 * shows the target user while API calls keep running with the previous token.
 * The previous auth is kept for its refreshToken / tokenProvider / apiKey so
 * the original session can be restored on unimpersonate.
 */
export const resolveIdentitySwitchAuth = (newAuth: AuthState, previousAuth: AuthState | null): AuthState =>
  previousAuth
    ? { ...previousAuth, jwtToken: newAuth.jwtToken }
    : { jwtToken: newAuth.jwtToken, apiKey: newAuth.apiKey ?? process.env.API_KEY ?? '' };
